import React, {Component} from 'react';
import TextField from '../../lib/mdb/text-field';
import Selectize from '../../lib/mdb/selectize';
import CheckboxField from '../../lib/mdb/checkbox-field.js';
import {camelCaseObject, mapMessages} from '../../lib/utils';


import {
    handleUnauthorizedRequest
} from '../../lib/payment-utils';
import DoNotSaveField from "./do-not-save-field";

import {
    CardHolderName,
    initPopover
} from "../../lib/payment-method-util"

/**
 *  This component renders fields for the e-check payment method.
 */
class PaymentMethodDDFields extends Component {

    constructor(props) {
        super(props);
        this.populateBankName = this.populateBankName.bind(this);
    }

    componentDidMount() {
        initPopover("popover-routing-number-link", "popover-routing-number");
    }

    /**
     *  Do an ajax call to rest xotp to retrieve the bank name by routing number.
     *  If response is valid then set the bank name into the state.
     */
    populateBankName(e) {
        const {state} = this.props,
            {config, setValues, data} = state,
            {nginxJwtToken} = data,
            {tla, xotpUser, messages, paymentConfig} = config,
            routingNumber = e.target.value;

        if (!routingNumber || !/^\d{9}$/.test(routingNumber)) {
            return;
        }

        let bankName = "";
        $.ajax({
            method: 'GET',
            // XOTP Url now relative to AD.
            url: `./xotp-api/bankInfo/${tla}/${routingNumber}?JWT_TOKEN=${encodeURIComponent(nginxJwtToken)}`,
            username: xotpUser,
            password: "",
            dataType: "json",
            success: (data) => {
                data = camelCaseObject(data) || {};
                data = data.bankInfoResponse || {};
                if (data.validationStatus === "PASSED") {
                    bankName = data.bankName;
                } else {
                    state.setErrorSync({
                        name: "paymentMethod.routingNumber",
                        value: messages["payment.invalidRoutingNumber.label"]
                    });
                }
            },
            error: (jqXHR, textStatus, errorThrown) => {
                console.log('Error: ', jqXHR, textStatus, errorThrown);
                if (jqXHR.status === 401) {
                    handleUnauthorizedRequest();
                    return;
                }
                state.setErrorSync({
                    name: "paymentMethod.routingNumber",
                    value: messages["payment.invalidRoutingNumber.label"]
                });
            },
            complete: function () {
                setValues((data) => {
                    data.paymentMethod.fiName = bankName;
                    return data;
                });
            }
        });
    }

    render() {
        const {paymentMethod, state, appComponents} = this.props,
            {config} = state,
            {messages, paymentConfig} = config,
            pmList = paymentConfig.paymentMethods.filter(item => item.categoryCode === 'DD'),
            emptyValue = "",
            routingValidations = paymentConfig.country === 'US' ? {
                required: messages["opp.validation.routingNumber.required"],
                validRoutingNumberUS: messages["opp.validation.routingNumber.invalid"]
            } : {
                required: messages["opp.validation.routingNumber.required"],
                validRoutingNumberCA: messages["opp.validation.routingNumber.invalid"]
            };

        const {BankAccountHolderName} = appComponents;
        return (
            <React.Fragment>
                <div className="col-md-6 col-12 order-0">
                    <Selectize
                        name="paymentMethod.type"
                        description={messages["payment.bankAccountType.label"]}
                        selectizeOptions={{
                        //     dropdownParent: "body",
                            highlight: false
                        }}
                        selectList={pmList}
                        autoComplete="off"
                        validations={{
                            required: messages["opp.validation.bankAccountType.required"]
                        }}>
                        <option value="">{emptyValue}</option>
                    </Selectize>
                </div>
                <div className="col-md-6 col-12 order-1">
                    <TextField
                        key="paymentMethod-routingNumber"
                        name="paymentMethod.routingNumber"
                        description={() => (
                            <React.Fragment>
                                {messages["payment.routingNumber.label"]}
                                <a key="popover-routing-number-link" id="popover-routing-number-link"
                                   tabIndex="-1" className="popover-link" data-toggle="popover" data-placement="auto"
                                   data-trigger="hover">
                                    <i className="material-icons">help</i></a>
                            </React.Fragment>
                        )}
                        maxLength="9"
                        className="md-form form-group"
                        labelClass="active has-popover"
                        aria-required="true"
                        validations={routingValidations}
                        autoComplete="off"
                        onBlur={this.populateBankName}/>
                </div>
                <div className="col-md-6 col-12 order-3 order-sm-3 order-md-2">
                    <TextField
                        key="paymentMethod-dd-accountNumber"
                        name="paymentMethod.accountNumber"
                        description={messages["payment.bankAccountNumber.label"]}
                        maxLength="20"
                        className="md-form form-group"
                        labelClass="active"
                        aria-required="true"
                        validations={{
                            required: messages["opp.validation.bankAccountNumber.required"],
                            validBankAccount: messages["opp.validation.bankAccountNumber.invalid"]
                        }}
                        autoComplete="off"/>
                </div>
                <div className="col-md-6 col-12 order-2 order-sm-2 order-md-3">
                    <span className="display-label">{messages["payment.bankName.label"]}</span>
                    <span className=" display-plaintext bankNameSpan">{paymentMethod.fiName}</span>
                </div>
                <div className="col-md-6 col-12 order-4">
                    <BankAccountHolderName
                        key="paymentMethod-dd-card-holder"
                        messages={messages}
                    />
                </div>
                {(paymentConfig && !paymentConfig.achAgreementChannelOverride) ?
                <div className="col-12 order-5">
                    <a href="#" data-toggle="modal" data-target="#modal-ach-agreement" data-backdrop="static">
                        {messages["payment.agreement.label"]}
                    </a>
                        <div className="form-group m-0">
                            <CheckboxField
                                key="paymentMethod-acceptDirectPaymentAgreement"
                                name="paymentMethod.acceptDirectPaymentAgreement"
                                description={messages["payment.agreement.accept"]}
                                className="form-check pl-0"
                                inputClass="form-check-input"
                                labelClass="form-check-label"
                                aria-required="true"
                                validations={{
                                    required: messages["opp.validation.customerAuthorization.required"]
                                }}
                            />
                        </div>
                </div>
                : <div/>}

                { (paymentConfig && paymentConfig.cpDoNotSavePmEnabled === 'true') ?
                    <div className="col-12 order-5">
                        <DoNotSaveField
                            messages={messages}
                        />
                    </div>
                    :<div/>}
                <RoutingNumberPopover config={config}/>
            </React.Fragment>
        );
    };
}

const RoutingNumberPopover = ({config}) => {
    return (
        <div className="modal" key="popover-routing-number" id="popover-routing-number" tabIndex="-1"
             aria-hidden="true">
            <img src={messages["opp.image_cheque_05"] || "images/image_cheque_05.png"}/>
        </div>
    );
};

export default PaymentMethodDDFields
